import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import React, { FC } from 'react';
import { EventType } from 'api/notifications/meta';
import { Group, CommonProps } from './group';

export const Reminders: FC<CommonProps> = ({
  onChange,
  mandatory,
  configurations,
}) => (
  <Group
    group="reminders"
    icon={<EventSchedule16 />}
    mandatory={mandatory}
    configurations={[
      EventType.TaskStartDateReminder,
      EventType.TaskDueDateReminder,
    ]
      .map((x) => configurations.find((c) => c.eventType === x)!)
      .filter(Boolean)}
    onChange={onChange}
  />
);
